<template>
  <div>
    <div v-if="selectedCompany && selectedCompany.hasDepartments">
      <!-- display card if  apprenticeships exist-->
      <v-card class="pb-8" flat>        
        <v-card class="v-card__container" flat>
          <v-data-table :headers="headers" :items="departments" sort-by="name" item-key="id" class="mt-6">
            <template slot="item.name" slot-scope="props">
              <div>
                {{ props.item.name }}
              </div>
            </template>
            <template slot="item.departmentWorkplaces" slot-scope="props">
              <div class="text-end">
                <a>{{ props.item.departmentWorkplaces }}</a>
              </div>
            </template>
            <template slot="item.instructors" slot-scope="props">
              <div class="text-end">
                <a>{{ props.item.instructors }}</a>
              </div>
            </template>
            <template slot="item.companyEducationResponsible" slot-scope="props">
              <div class="text-end">
                <a>{{ props.item.companyEducationResponsible }}</a>
              </div>
            </template>
            <template slot="item.apprenticeships" slot-scope="props">
              <div class="text-end">
                <a>{{ props.item.apprenticeships }}</a>
              </div>
            </template>

            <template slot="item.action" slot-scope="props">
              <div class="text-end">
                <v-icon class="ma-2" @click.stop="showEditCreate(props.item)" :disabled="!canUpdate">$sl-edit</v-icon>
                <v-icon @click.stop="deleteDepartment(props.item)" :disabled="!canDelete">$sl-delete</v-icon>
              </div>
            </template>
          </v-data-table>

          <v-btn data-cy="add-new-department" absolute bottom right fab @click="showEditCreate({})" :disabled="!canCreate">
            <v-icon class="ml-1">$sl-add</v-icon>
          </v-btn>
        </v-card>
      </v-card>
      <!-- The Dialog -->
      <v-dialog v-model="showCreateOrEdit" max-width="600px">
        <CreatedEditModal
          v-model="department"
          @close="
            showCreateOrEdit = false
            getDepartments()
          "
        />
      </v-dialog>
    </div>
    <div v-else class="text-center mt-7">
      <p class="font-weight-bold">Detta företag har inte givits tillgång till avdelningsfunktionen.</p>
      <p>Det går att aktivera avdelningar för detta företag under fliken “status”.</p>
    </div>
  </div>
</template>

<script>
import API from '@/services/api.js'

import CreatedEditModal from '@/components/company/departments/CreatedEditModal'
import {CanIDo} from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'
// @group Company
// Styled CompanyDepartaments component
export default {
  name: 'CompanyDepartaments',
  mixins: [CanIDo],
  components: {
    CreatedEditModal
  },
  props: {
    reRender: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reRender(newValue, oldValue) {
      this.getDepartments()
    }
  },
  data() {
    return {
      showCreateOrEdit: false,
      departments: [],
      department: {}
    }
  },

  created() {
    this.getDepartments()
  },
  computed: {
    ...mapGetters('company', ['selectedCompany']),
    headers() {
      return [
        {text: 'NAMN', value: 'name', width: '216'},
        {text: 'BESKRIVNING', value: 'description', sortable: false, width: '216'},
        {text: 'ARBETSPLATSER', value: 'departmentWorkplaces', sortable: false, width: '160', class: 'text-end'},
        {text: 'HANDLEDARE', value: 'instructors', sortable: false, width: '160', class: 'text-end'},
        {
          text: 'YRKESUTBILDNINGSANSVARIGA',
          value: 'companyEducationResponsible',
          sortable: false,
          width: '160',
          class: 'text-end'
        },
        {text: 'LÄRLINGAR', value: 'apprenticeships', sortable: false, width: '160', class: 'text-end'},
        {text: 'Ändra', value: 'action', sortable: false, width: '120', class: 'text-end'}
      ]
    }
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('company', 'delete');
    },
    canUpdate(){
      return this.canIDo('company', 'update');
    },
    canCreate(){
      return this.canIDo('company', 'create');
    }
  },

  methods: {
    ...mapActions('company', ['updateSelectedCompany']),
    showEditCreate(val) {
      val ? (this.department = val) : (this.department = {})
      this.showCreateOrEdit = true
    },
    // @vuese
    //- Used to get all the  employements from the selected company and display data in table
    getDepartments() {
      this.departments = []
      API.listDepartments(this.selectedCompany.id)
        .then(response => {
          response.data.forEach(d => {
            let app = 0
            d.departmentWorkplaces.forEach(e => {
              if (e.workplace && e.workplace.apprenticeships) {
                app = e.workplace.apprenticeships.length
              }
            })
            this.departments.push({
              id: d.id,
              name: d.name ? d.name : '',
              description: d.description ? d.description : '',
              instructors: d.instructors ? d.instructors.length : 0,
              administrators: d.administrators ? d.administrators.length : 0,
              apprenticeships: app,
              companyEducationResponsible: d.companyEducationResponsible ? d.companyEducationResponsible.length : 0,
              departmentWorkplaces: d.departmentWorkplaces ? d.departmentWorkplaces.length : 0,
              instructorIds: d.instructorIds ? d.instructorIds : [],
              companyEducationResponsibleIds: d.companyEducationResponsibleIds ? d.companyEducationResponsibleIds : [],
              distanceEducationAdministratorIds: d.distanceEducationAdministratorIds
                ? d.distanceEducationAdministratorIds
                : [],
              administratorIds: d.administratorIds ? d.administratorIds : [],
              workplaceIds: d.workplaceIds ? d.workplaceIds : []
            })
          })
        })
        .catch(error => {
          console.log('get departments', error)
        })
    },
    async deleteDepartment(item) {
      const res = await this.$dialog.confirm({
        title: 'Vill du verkligen radera avdelningen?',
        text: 'Radering av avdelningar går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      API.deleteDepartment(this.selectedCompany.id, item.id)
        .then(reponse => {
          const index = this.departments.indexOf(item)
          this.departments.splice(index, 1)
          this.$events.fire('showInfo', 'Raderad.')
        })
        .catch(error => {
          this.$events.fire(
            'showError',
            'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
          )
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>